import React, { useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Reset_Password from "../../assets/auth/reset-password.png";
import pass_on from "../../assets/auth/pass-on.png";
import pass_off from "../../assets/auth/pass-off.png";
import Close_Button from "../../assets/auth/close.png";
import Styles from "../../styles/admin/password.module.scss";
import { resetAdminPasswordService } from "../../services";
import { useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { setAdminLogout } from "../../redux";

const ResetPassword = () => {
  const navigate = useNavigate();
  // const { token } = useParams();
  let passwordRef = useRef("");
  let cpasswordRef = useRef("");
  const [showPassword, setShowPassword] = useState(false);
  // const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleLogout = async () => {
    dispatch(setAdminLogout());
    navigate(adminRoutes.login);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (true) {
      const success = await resetAdminPasswordService(
        // token,
        passwordRef.current?.value,
        cpasswordRef.current?.value
      );
      if (success) {
        Swal.fire({
          html: `
      <div style="text-align: center; border-radius: 20px; position: relative; font-family: 'gothambold', sans-serif;">
      <button 
        id="customCloseButton" 
        style="position: absolute; top: -10px; right: -20px; background: none; border: none; cursor: pointer;">
        <img 
          src=${Close_Button} 
          alt="Close" 
          style="width: 50px; height: 50px;"
        />
      </button>
      <img 
        src=${Reset_Password} 
        alt="Success" 
        style="width: 100px; margin-bottom: 20px; margin-top: 30px;" 
      />
      <h2 style="margin: 0; font-family: 'gothambold', sans-serif;">Password Changed!</h2>
            <br/>
      <p style="font-family: 'Gotham Book', sans-serif;">
        You’ve successfully completed your password reset.
      </p>
      <br/>
      <button 
        id="okButton" 
        style="
          background: linear-gradient(0deg, #151515 0%, #525252 100%); 
          color: #f3f3f6; 
          padding: 10px 30px; 
          border: none; 
          border-radius: 5px; 
          cursor: pointer; 
          margin-top: 20px; 
          font-family: 'gothambold', sans-serif;
        ">
        Login Now
      </button>
    </div>
        `,
          showConfirmButton: false,
          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const thanksButton = document.getElementById("okButton");
            thanksButton.addEventListener("click", () => {
              Swal.close();
              handleLogout();
              navigate(adminRoutes.login);
            });
          },
        });
      }
    }
  };
  return (
    <div className={Styles.dashboard_main}>
      <Navbar />

      <div className={Styles.dashboard_flexmain_head}>
        <div className={Styles.dashboard_flexmain}>
          <div className={Styles.flexdivider_2_title}>
            <h2>Change Password</h2>
          </div>

          <div className={Styles.flexdivider_2}>
            <div className={Styles.flexdivider_2_formcontainer}>
              <form autoComplete="" onSubmit={handleSubmit}>
                <div className={Styles.flexdivider_2_formcontainer_password}>
                  <label className={Styles.password}>
                    Enter Current Password
                  </label>
                  <input
                    placeholder="Enter Current password"
                    name="newPassword"
                    minLength={6}
                    maxLength={50}
                    ref={passwordRef}
                    type={showPassword ? "text" : "password"}
                    required
                  />
                  <div
                    type="button"
                    onClick={togglePasswordVisibility}
                    className={Styles.eyeIcon}
                  >
                    <img
                      src={showPassword ? pass_on : pass_off}
                      alt="Toggle password visibility"
                      className={Styles.eyeImage}
                    />
                  </div>
                </div>

                <div className={Styles.flexdivider_2_formcontainer_password}>
                  <label className={Styles.label}>Enter new password</label>
                  <input
                    placeholder="Enter new password"
                    name="confirmPassword"
                    minLength={6}
                    maxLength={50}
                    ref={cpasswordRef}
                    type={showPassword ? "text" : "password"}
                    required
                  />
                  <div
                    type="button"
                    onClick={togglePasswordVisibility}
                    className={Styles.eyeIcon}
                  >
                    <img
                      src={showPassword ? pass_on : pass_off}
                      alt="Toggle password visibility"
                      className={Styles.eyeImage}
                    />
                  </div>
                </div>
                <br />
                <br />
                <div className={Styles.flexdivider_2_formcontainer_button}>
                  <button type="submit">
                    {" "}
                    <span>SUBMIT</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
